import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import {
  AllContactDetailsByMasterQuery,
  AllContactDetailsByUserQuery,
  AllContactDetailsQuery,
  AllEmployeeDetailsQuery,
} from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import BASEURL from "../Utils/Baseurl";
import TableComponent from '../../components/GridTable/TableComponent'

export default function ContactListTable() {
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const navigate = useNavigate();
  const [contactData, setContactData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const contactListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        sortable: true,
        editable: false,
      },
      {
        label: "Contact ID",
        field: "conid",
        flex: 1,
        sortable: true,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "First Name",
        field: "firstName",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Last Name",
        field: "lastName",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },

      {
        label: "Organization Name",
        field: "organizationName",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Organization Type",
        field: "organizationType",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Email ID",
        field: "mailId",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },

      {
        label: "Created By",
        field: "createdBy",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },

      {
        label: "Created At",
        field: "createdAt",
        flex: 1,
        sortable: true,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: contactData.reverse().map((val, index) => ({
      sno: index + 1,
      id: val.id,
      conid: val.conid,
      firstName: val.firstName,
      lastName: val.lastName,
      role: val.role,
      organizationName: val.organizationName,
      organizationType: val.organizationType,
      mailId: val.mailId,
      createdBy: val.user.username,
      createdAt: val.createdAt ? val.createdAt.slice(0, 10) : "N/A",
    })),
  };

  const fetchContactData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? AllContactDetailsByMasterQuery
        : isUser.toLowerCase() == "employee"
        ? AllContactDetailsByUserQuery
        : isUser.toLowerCase() == "superuser"
        ? AllContactDetailsQuery
        : "",

      { id: currentUser?.id }
    )
      .then((res) => {
        setContactData(
          isUser.toLowerCase() == "manager"
            ? res.getContactdetailByMaster
            : isUser.toLowerCase() == "employee"
            ? res.getContactdetailByUser
            : isUser.toLowerCase() == "superuser"
            ? res.allContact
            : []
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchContactData();
    setStatus(false);
  }, [id, status]);

  const handleNewContact = () => {
    navigate("/contact/add-contact");
  };

  const onContactListClick = (e) => {
    if (e?.id) {
      navigate(`/contact/add-contact?${e?.id}`);
    }
  };

const onDelete=(id)=>
{
  console.log("id-d",id)
}

const onCheck=(list)=>
{
  console.log("id-c",list)
}

const onDeleteALL=()=>
{
  console.log("id-DELE")
}


  return (
    <DashboardLayout>
      
       <TableComponent
      tableLoading={isLoading ? true : false }  
      columns={contactListTable.columns}
      rowsData={contactListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Contact List"
      actions={true}
      checked={false}
      view={true}
      onCheck={onCheck}
      showAdd = {true}
      onEdit={onContactListClick}
      onDelete={onDelete}
      onView={onContactListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewContact()}
      />

      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Contact List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewContact()}
              >
                Add Contact
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            // customHeight={550}
            rows={contactListTable.rows}
            columns={contactListTable.columns}
            onRowClick={onContactListClick}
            loading={pageState.loading}
            // checkboxSelection={false}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Contact found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any Contact details. Click on the "Add
                    Contact" button to start adding contact details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
